

import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { environment } from "environments/environment";
import { retry, catchError, tap, finalize } from "rxjs/operators";
import { Injectable, Injector, inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { BankProgressBarService } from "@core/components/progress-bar/progress-bar.service";
import { UtilsService } from "@core/services/utils/utils.service";
import { MatDialog } from "@angular/material/dialog";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: "root" })

export class ApiSecurityService {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------
  @BlockUI() blockUI: NgBlockUI;
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private apiURL: string = environment.ipServer;
  private path: string = environment.security_path;

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _httpClient: HttpClient,
    private _mStorage: manageStorageService,
    private _bankProgressBarService: BankProgressBarService,
    private _cookieService: CookieService,
    private dialogRef: MatDialog // all windows
  ) {

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * [handleError]  Error handling
   * @param error
   */

  private handleError(error: any) {

    let  
    errorMessage = {
      message:
        (error)
          ?  error.message
          : "",
      codeError: error.codeError,
      wsName: error.wsName 
    };

    return throwError(() => errorMessage);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
     * [send] send data to web service
     * @param keyService
     * @param dataSend
     */
  public shortPath(
    keyService: string,
    dataSend: any = {}, optionPost: any = {}): Observable<HttpResponse<Object>> {

    let shortPathSec = 'casa-bolsa-seguridad/';

    return this._httpClient.post<HttpResponse<Object>>
      (
        `${this.apiURL}${shortPathSec}${keyService}`, dataSend, { params: optionPost })
      .pipe(
        retry(0), tap(),
        catchError(this.handleError));
  }
  /**
     * [send] send data to web service
     * @param keyService
     * @param dataSend
     */
  public poSt(
    keyService: string,
    dataSend: any = {}, optionPost: any = {}): Observable<HttpResponse<Object>> {
    return this._httpClient.post<HttpResponse<Object>>
      (
        `${this.apiURL}${this.path}${keyService}`,
        dataSend, { params: optionPost })
      .pipe(
        retry(0), tap(),
        catchError(this.handleError));
  }

  /**
   * [gEt]
   * @param keyService 
   * @param qryParms 
   * @returns 
   */
  public gEt(keyService: string, qryParms: any = undefined) {

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this._bankProgressBarService.show();
    this.blockUI.start();

    return this._httpClient.get(`${this.apiURL}${this.path}${keyService}`, {
      params: qryParms,
      observe: "response",
      headers: reqHeader
    })
      .pipe(
        retry(0),
        tap(),
        catchError(this.handleError),
        finalize(() => {
          this._bankProgressBarService.hide();
          this.blockUI.stop();
        })
      )
  }


}
